require('./hireCardMetallicView.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');

// @helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @actions
const hireCardMetallicActions = require('actions/hireCardMetallic');
const hireCardImageSelectorActions = require('actions/hireCardImageSelector');
const preContractualMailActions = require('actions/contactCenter/preContractualMailInfo/preContractualMailInfo');
const profileActions = require('actions/profile');
const shippingAddressAction = require('actions/shippingAddress');
const mergePreContractualsPDF = require('actions/mergePreContractualsPDF');
const termsAndCondsInfoActions = require('actions/termsAndCondsInfo');
const precontractualDocumentMailAction = require('actions/precontractualDocumentsMailer');

// @commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @components
const HireCardMetallicStep1 = require('components/hire/cardMetallic/hireCardMetallicStep1/hireCardMetallicStep1');
const HireCardMetallicStep2 = require('components/hire/cardMetallic/hireCardMetallicStep2/hireCardMetallicStep2');
const HireCardMetallicStep3 = require('components/hire/cardMetallic/hireCardMetallicStep3/hireCardMetallicStep3');
const HireCardMetallicStep4 = require('components/hire/cardMetallic/hireCardMetallicStep4/hireCardMetallicStep4');
const HireCardMetallicSuccess = require('components/hire/cardMetallic/hireCardMetallicSuccess/hireCardMetallicSuccess');
const HireCardMetallicError = require('components/hire/cardMetallic/hireCardMetallicError/hireCardMetallicError');
const HireCardSidebar = require('components/hire/hireCardSidebar/hireCardSidebar');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const WebappRender = require('components/conditionalRender/webappRender')
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const InactiveAccountsError = require('components/commons/inactiveAccountsError/inactiveAccountsError');

// @constants
const {
    ACCOUNT_INTERVENTION_CO_OWNER,
    ACCOUNT_INTERVENTION_OWNER,
    ACCOUNT_INTERVENTION_AUTHORIZED,
    CHECKING_ACCOUNT_CODE,
    EURO_TEXT,
    REDIRECT_URL,
    SECOND_STEP,
    WIZARD_FIRST_STEP
} = require('constants/index');
const { METAL_CARD_VALIDATIONS, MESSAGE_HIRE_24H } = require('constants/flagBasedFeatures');

// @constants
const {
    METALLIC_CARD_TYPE,
    METALLIC_STANDARD,
    METALLIC_SUBTYPE_DE,
    METALLIC_SUBTYPE_NL,
    METALLIC_SUBTYPE_PT,
} = require('constants/cards');
const { ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES } = require('constants/accounts');
const { ES_COUNTRY } = require('constants/flagBasedFeatures');
const cardImageIds = {
    default: 'B.506.20.001',
    de: 'B.506.20.001',
    nl: 'B.506.21.001',
    pt: 'B.506.22.001',
}


class HireCardMetallicView extends React.Component {
    constructor(props) {
        super(props);
        this.isReady = this.isReady.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        const {
            getHireCardImages,
            match: { params: { redirect } },
            validateStep,
            getshippingAddressList
        } = this.props;

        getHireCardImages([this.getCardImage()]);

        if (redirect === REDIRECT_URL) {
            validateStep(WIZARD_FIRST_STEP);
        }
        getshippingAddressList();
    }

    componentWillUnmount() {
        const {
            reset,
            resetPrecontractualMail,
            resetTermsAndCondsText,
        } = this.props;

        reset();
        resetTermsAndCondsText();

        if (__CONTACT_CENTER__) {
            resetPrecontractualMail();
        }
    }

    getProcessDetail() {
        return `${METALLIC_CARD_TYPE}.${this.getCardSubtype()}`;
    }

    getCardImage() {
        const { immProfile } = this.props;
        return cardImageIds[immProfile.get('originCountry').toLowerCase()] || cardImageIds['default'];
    }

    getCardSubtype() {
        const { immProfile } = this.props;
        const country = immProfile.get('originCountry');
        let subtype = METALLIC_SUBTYPE_DE;

        if (country === 'NL') {
            subtype = METALLIC_SUBTYPE_NL;
        } else if (country === 'PT') {
            subtype = METALLIC_SUBTYPE_PT;
        }

        return subtype;
    }

    handleCancel() {
        this.props.history.push('/myprofile/cards');
    }

    isReady() { // it warns the user if he's about to lose changes
        const { immHireCardMetallic } = this.props;
        let showPreLeaveModal = true;

        if (immHireCardMetallic.get('visibleStep') === 1) {
            showPreLeaveModal = false;
        }

        return showPreLeaveModal;
    }

    buildSuccessful() {
        const {
            immAccounts,
            immHireCardImageSelector,
            immHireCardNameSelector,
            immHireCardMetallic,
            immProfile,
            immShippingAddressList
        } = this.props;
        const selectedAccount = immHireCardMetallic.getIn(['steps', SECOND_STEP, 'accountId']);
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);

        const processDetail = this.getProcessDetail();

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <HireCardMetallicSuccess
                    immAccount={immAccount}
                    immHireCardImageSelector={immHireCardImageSelector}
                    immHireCardNameSelector={immHireCardNameSelector}
                    immHireCardMetallic={immHireCardMetallic}
                    immProfile={immProfile}
                    immShippingAddress={immShippingAddressList}
                    originCountry={immProfile.get('originCountry')}
                    processDetail={processDetail}
                />
            </div>
        );
    }

    filterAccounts() {
        const { immAccounts } = this.props;
        const immAcountsWithoutDebitCard = this.getAccountsWithoutDebitCard();
        const interventionTypes = [
            ACCOUNT_INTERVENTION_OWNER,
            ACCOUNT_INTERVENTION_CO_OWNER,
        ];

        if (__CONTACT_CENTER__) {
            const index = interventionTypes.indexOf(ACCOUNT_INTERVENTION_AUTHORIZED);
            if (index > -1) {
                interventionTypes.splice(index, 1);
            }
        }

        const accountsIndexes = immAcountsWithoutDebitCard.filter(accountId =>
            // We remove the accounts that are not in euros
            immAccounts.getIn(['byId', accountId, 'balance', 'currency']) === EURO_TEXT
        ).filter(accountId =>
            // We remove the accounts that don't comply with the requisites of product type and subtype
            immAccounts.getIn(['byId', accountId, 'newProduct']) === String(CHECKING_ACCOUNT_CODE) &&
            ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES.includes(immAccounts.getIn(['byId', accountId, 'accountType']))
        ).filter(accountId =>
            // We remove the accounts where the user is not the owner
            interventionTypes.includes(immAccounts.getIn(['byId', accountId, 'interventionType']))
        );

        // We return an array with the ids of the filtered accounts
        return accountsIndexes.toJS();
    }

    getAccountsWithoutDebitCard() {
        const { immAccounts, immCards } = this.props;
        return immAccounts.get('byOrder').filter(accountId => {
            const accountHasDebit = immCards.getIn(['debit', 'byOrder']).find(cardId => {
                const immCard = immCards.getIn(['byId', cardId]);
                return immCard.get('isMetallic') &&
                    immCard.get('status') === 'EN VIGOR' &&
                    (immCard.get('associatedAccountShort') === immAccounts.getIn(['byId', accountId, 'contractNumber']));
            });

            return !accountHasDebit;
        });
    }

    buildWizardHiringSteps() {
        const {
            flagBasedFeatures,
            gestorCrossEnabled,
            handleAccountChange,
            handleAgreementCheckboxChange,
            hireCardMetallic,
            immAccounts,
            immHireCardImageSelector,
            immHireCardNameSelector,
            immHireCardMetallic,
            immHireInformation,
            immHiringProductInformation,
            immHireContactData,
            immPreContractualMail,
            immProfile,
            immPdfData,
            immShippingAddressList,
            immContracts,
            isInactiveAccountsEnabled,
            requestPDFMerge,
            requestProfile,
            sendPrecontractualDocumentMail,
            sendPreContractualMail,
            setAllAccountsToInactive,
            setVisibleStep,
            setWillCancel,
            setShippingAddress,
            setTermsAndCondsText,
            validateStep,
            immMetalCard
        } = this.props;
        const wizardActions = {
            cancel: this.handleCancel,
            finish: hireCardMetallic,
            setVisibleStep,
            setWillCancel,
            validateStep
        };
        const showPreLeaveModal = this.isReady();
        const immSteps = immHireCardMetallic.get('steps');
        const sendMailParams = {
            type: METALLIC_CARD_TYPE,
            subType: this.getCardSubtype(),
            standar: METALLIC_STANDARD
        };
        let hasShippingAddress = true;

        const tealium = {
            processDetail: this.getProcessDetail()
        }
        const applyMetalCardValidations = flagBasedFeatures.get(METAL_CARD_VALIDATIONS);
        const isShippingAddressButtonDisabled = !!immShippingAddressList && !immShippingAddressList.get('shippingAddressType') && flagBasedFeatures.get(ES_COUNTRY);
        const loadingFlag = immHireCardMetallic.get('loadingFlag');

        return (
            <div>
                <div className="col-xs-12 col-md-8">
                    <Wizard
                        actions={wizardActions}
                        immSteps={immSteps}
                        showPreLeaveModal={showPreLeaveModal}
                        stepsAmount={immSteps.size}
                        tealium={tealium}
                        visibleStep={immHireCardMetallic.get('visibleStep')}
                        wizardClass="hire-card-metallic__wizard"
                    >
                        <WizardStep
                            cancelButton={true}
                            position="first"
                            loadingFlag={loadingFlag}
                        >
                            <WebappRender>
                                <HireCardMetallicStep1
                                    flagBasedFeatures={flagBasedFeatures}
                                    gestorCrossEnabled={gestorCrossEnabled}
                                    hireCmsKey="metallic"
                                    immHireInformation={immHireInformation}
                                    immHiringProductInformation={immHiringProductInformation}
                                    requestPDFMerge={requestPDFMerge}
                                    contracts={immContracts}
                                />
                            </WebappRender>
                            <ContactCenterRender>
                                <HireCardMetallicStep1
                                    contractName="metallic"
                                    flagBasedFeatures={flagBasedFeatures}
                                    gestorCrossEnabled={gestorCrossEnabled}
                                    handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                                    hireCmsKey="metallic"
                                    immHireCardMetallic={immHireCardMetallic}
                                    immHireInformation={immHireInformation}
                                    immHiringProductInformation={immHiringProductInformation}
                                    immPreContractualMail={immPreContractualMail}
                                    immProfileFields={immProfile}
                                    requestProfile={requestProfile}
                                    sendMailParams={sendMailParams}
                                    sendPreContractualMail={sendPreContractualMail}
                                    setTermsAndCondsText={setTermsAndCondsText}
                                    requestPDFMerge={requestPDFMerge}
                                    contracts={immContracts}
                                />
                            </ContactCenterRender>
                        </WizardStep>
                        <WizardStep
                            cancelButton={true}
                            onBackClick={false}
                            position="middle"
                            nextButtonDisabled={immHireCardMetallic.getIn(['steps', SECOND_STEP, 'hasInsufficientBalance'], false)}
                        >
                            <HireCardMetallicStep2
                                accountsIndexesFiltered={this.filterAccounts()}
                                handleAccountChange={handleAccountChange}
                                immAccounts={immAccounts}
                                immHireCardNameSelector={immHireCardNameSelector}
                                immHireCardMetallic={immHireCardMetallic}
                                isInactiveAccountsEnabled={isInactiveAccountsEnabled}
                                setAllAccountsToInactive={setAllAccountsToInactive}
                                contracts={immContracts}
                                immMetalCard={immMetalCard}
                                applyMetalCardValidations={applyMetalCardValidations}
                            />
                        </WizardStep>
                        <WizardStep
                            cancelButton={true}
                            onBackClick={false}
                            position="middle"
                            nextButtonDisabled={isShippingAddressButtonDisabled}
                        >
                            <HireCardMetallicStep3
                                immHireContactData={immHireContactData}
                                immShippingAddressList={immShippingAddressList}
                                setShippingAddress={setShippingAddress}
                            />
                        </WizardStep>
                        <WizardStep
                            addLoadingBehaviour={true}
                            cancelButton={true}
                            immFinalButton={'hireCardMetallic-hire'}
                            isLoading={immHireCardMetallic.get('isFetching')}
                            onBackClick={false}
                            position="last"
                        >
                            <HireCardMetallicStep4
                                immAccounts={immAccounts}
                                immHireCardNameSelector={immHireCardNameSelector}
                                immHireCardMetallic={immHireCardMetallic}
                                immShippingAddress={immShippingAddressList}
                                handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                                operativeName={__CONTACT_CENTER__ ? "operatives-Metallic" : undefined}
                                originCountry={immProfile.get('originCountry')}
                                sendPrecontractualDocumentMail={sendPrecontractualDocumentMail}
                                setTermsAndCondsText={setTermsAndCondsText}
                                immPdfData={immPdfData}
                                immMetalCard={immMetalCard}
                                applyMetalCardValidations={applyMetalCardValidations}
                            />
                        </WizardStep>
                    </Wizard>
                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="row">
                        <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
                            <HireCardSidebar
                                immAccounts={immAccounts}
                                immAddress={immShippingAddressList.get('shippingAddress')}
                                immHireCardImageSelector={immHireCardImageSelector}
                                immHireCardNameSelector={immHireCardNameSelector}
                                immProfile={immProfile}
                                immShippingAddressList={immShippingAddressList}
                                selectedAccount={immSteps.getIn([SECOND_STEP, 'accountId'])}
                                type="debit"
                                hasShippingAddress={hasShippingAddress}
                            />
                        </div>
                        <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                            <CallMeBack context="contracts" modifier="contracts-view" pageTitle={formatText('breadcrumb-cards')} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { immHireCardMetallic, flagBasedFeatures } = this.props;
        const pageTitle = getFinalTitle('hireCardMetallic-pageTitle');
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: formatText("hireCardMetallic-breadcrumb")
            }
        ];
        const isErrorAvailableAccounts = this.filterAccounts().length === 0;

        const processDetail = this.getProcessDetail();
        const hireRestrictionFlag = immHireCardMetallic.getIn(['steps', WIZARD_FIRST_STEP - 1, 'hireRestriction']);
        const hireRestrictionFF = flagBasedFeatures.get(MESSAGE_HIRE_24H);

        let content;

        if (immHireCardMetallic.get('error') || isErrorAvailableAccounts) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HireCardMetallicError
                        immHireCardMetallic={immHireCardMetallic}
                        isErrorAvailableAccounts={isErrorAvailableAccounts}
                        processDetail={processDetail}
                    />
                </div>
            );
        } else if (hireRestrictionFlag && hireRestrictionFF) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HireCardMetallicError
                        immHireCardMetallic={immHireCardMetallic}
                        isErrorAvailableAccounts={isErrorAvailableAccounts}
                        processDetail={processDetail}
                        hireRestrictionFlag={hireRestrictionFlag}
                    />
                </div>
            );
        } else if (immHireCardMetallic.get('submitSuccessful')) {
            content = this.buildSuccessful();
        } else if (immHireCardMetallic.get('allAccountsInactive')) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <InactiveAccountsError
                        navigateToBackButtonText={'cards'}
                        navigateToBackButtonURL={'cards'}
                    />
                </div>
            );
        } else {
            content = this.buildWizardHiringSteps();
        }

        return (
            <div className="hire-card-metallic">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={pageTitle}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

HireCardMetallicView.propTypes = {
    flagBasedFeatures: PropTypes.object.isRequired,
    getHireCardImages: PropTypes.func.isRequired,
    gestorCrossEnabled: PropTypes.bool,
    handleAccountChange: PropTypes.func.isRequired,
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    hireCardMetallic: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardMetallic: PropTypes.object.isRequired,
    immHireContactData: PropTypes.object.isRequired,
    immHireInformation: PropTypes.object.isRequired,
    immHiringProductInformation: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    requestPDFMerge: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    immProfile: PropTypes.object.isRequired,
    immPdfData: PropTypes.object.isRequired,
    immContracts: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    match: PropTypes.object,
    reset: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    resetTermsAndCondsText: PropTypes.func.isRequired,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    getshippingAddressList: PropTypes.func,
    immShippingAddressList: PropTypes.object,
    setShippingAddress: PropTypes.func,
    immMetalCard: PropTypes.object.isRequired
};

module.exports.constructor = HireCardMetallicView;
module.exports.HireCardMetallicView = connect(
    state => ({
        flagBasedFeatures: state.flagBasedFeatures,
        gestorCrossEnabled: state.flagBasedFeatures.get('web-gc-enabled'),
        immAccounts: state.accounts,
        immCards: state.cards,
        immContracts: state.globalVariables.getIn(['variables', 'parameters', 'contratos']),
        immMetalCard: state.globalVariables.getIn(['variables', 'parameters', 'metal_card']),
        immHireCardImageSelector: state.hireCardImageSelector,
        immHireCardNameSelector: state.hireCardNameSelector,
        immHireCardMetallic: state.hireCardMetallic,
        immHireCreditLimit: state.hireCreditLimit,
        immHireInformation: state.hireInformation,
        immHiringProductInformation: state.hiringProductInformation,
        immHirePaymentMethod: state.hirePaymentMethod,
        immHireContactData: state.hireContactData,
        immPreContractualMail: state.preContractualMail,
        immProfile: state.profile,
        immPdfData: state.precontractualsMergePdfs,
        immShippingAddressList: state.shippingAddress,
        isInactiveAccountsEnabled: state.flagBasedFeatures.get('web-inactive-account-enabled'),
    }),
    {
        getHireCardImages: hireCardImageSelectorActions.getHireCardImages,
        getshippingAddressList: shippingAddressAction.getShippingAddressList,
        handleAccountChange: hireCardMetallicActions.setAccount,
        handleAgreementCheckboxChange: hireCardMetallicActions.setAgreementCheckbox,
        hireCardMetallic: hireCardMetallicActions.hireCardMetallic,
        requestPDFMerge: mergePreContractualsPDF.requestPDFMerge,
        requestProfile: profileActions.requestProfile,
        reset: hireCardMetallicActions.reset,
        resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
        resetTermsAndCondsText: termsAndCondsInfoActions.reset,
        sendPrecontractualDocumentMail: precontractualDocumentMailAction.sendPrecontractualDocumentMail,
        sendPreContractualMail: preContractualMailActions.sendPreContractualMail,
        setAllAccountsToInactive: hireCardMetallicActions.setAllAccountsToInactive,
        setShippingAddress: shippingAddressAction.setShippingAddress,
        setTermsAndCondsText: termsAndCondsInfoActions.setTermsAndCondsText,
        setVisibleStep: hireCardMetallicActions.setVisibleStep,
        setWillCancel: hireCardMetallicActions.setWillCancel,
        validateStep: hireCardMetallicActions.validateStep,
    }
)(withRouter(HireCardMetallicView));
